import { defineComponent as _defineComponent } from 'vue'
import { BattleDB } from '@/enitites/battle'

interface IProps {
  battle: BattleDB
  waitListLength: number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BattleWaitList',
  props: {
    battle: null,
    waitListLength: null
  },
  setup(__props: any) {



return { __sfc: true, }
}

})